export default __webpack_public_path__ + "static/media/Greyline-pdfm50 Instrument.20fb066a.jpeg";